import { Image, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDataItemProps {
  header: string;
  text: string;
  image?: string | null;
  url?: string;
  onClick?: () => void;
}

export const DataItem: React.FC<IDataItemProps> = ({ image, header, text, url, onClick }) => {
  return (
    <div className={styles['item']}>
      {image && image.length ? (
        <div className={styles['image']}>
          <a href={url} target="_blank" rel="noreferrer" className={styles['link']} onClick={onClick}>
            {<Image src={image} borderRadius="4px" width={44} height={44} objectFit="contain" />}
          </a>
        </div>
      ) : null}
      <div>
        <UIText2 color="text-secondary-default">{header}</UIText2>
        {url ? (
          <a href={url} target="_blank" rel="noreferrer" className={styles['link']} onClick={onClick}>
            <UIHeading4 as="h4" color="current_color">
              {text}
            </UIHeading4>
          </a>
        ) : (
          <UIHeading4 color="text-primary-default">{text}</UIHeading4>
        )}
      </div>
    </div>
  );
};
